import React from "react";
import { Link } from "react-router-dom";
import IRAM from "../assets/images/sidom/fotos/sellos web.png";

import logo from "../assets/images/sidom/fotos/SIDOM-LOGO_BLANCO.png";

import { FiLinkedin, FiInstagram } from "../assets/icons/vander";
import { Link as ScrollLink } from "react-scroll";

export default function Footer() {
  return (
    <footer className="relative bg-sidom-blue overflow-hidden">
      <div className=" box w-full min-h-[30px] md:min-h-[80px] lg:min-h-[20px] flex items-center justify-center text-center text-sidom-light text-lg md:text-xl lg:text-2xl px-2 md:px-8"></div>
      <div className="py-[30px] px-2 md:px-0 container mx-auto">
        <div className="relative">
          <div className="w-full flex flex-col  justify-center items-center">
            <div className="flex flex-col md:flex-row lg:flex-row gap-6 justify-start mt-6 md:mt-0 w-full">
              <div className="flex flex-col justify-center  items-center gap-4 w-full md:w-1/2 lg:w-1/3">
                <div className="flex flex-col justify-start items-start w-full">
                  <Link to="/" className="flex focus:outline-none w-full">
                    <img
                      src={logo}
                      className="w-[80%] md:w-[80%] lg:w-[80%] inline-block"
                      alt="SIDOM logo"
                    />
                  </Link>
                </div>
                <div className="flex flex-row gap-4 h-full justify-end items-end mt-6 md:mt-0 w-full">
                  <div>
                    <img
                      src={IRAM}
                      className="w-[80%] md:w-[80%] lg:w-[80%] inline-block"
                      alt="blo"
                    />
                  </div>
                </div>
              </div>
              <div className="flex flex-col justify-end  md:flex-row gap-2 w-full md:w-1/2 lg:w-2/3">
                <div className="flex-1 flex  flex-col gap-2 text-sidom-light text-left mt-6 md:mt-0 min-w-[100px] max-w-[150px]">
                  <h2 className="text-lg font-bold">Servicios</h2>
                  <ScrollLink
                    to="section-two"
                    smooth={true}
                    duration={400}
                    className="hover:text-sidom-orange cursor-pointer"
                  >
                    Global Trade
                  </ScrollLink>
                  <Link
                    to="/sidom-smart-reader"
                    className="hover:text-sidom-orange"
                  >
                    SIDOM Smart Reader
                  </Link>
                  <Link
                    to="/sidom-insurance"
                    className="hover:text-sidom-orange"
                  >
                    SIDOM Insurance
                  </Link>
                  <Link to="/sidom-pay" className="hover:text-sidom-orange">
                    SIDOM Pay
                  </Link>

                  <Link to="/sidom-mre" className="hover:text-sidom-orange">
                    SIDOM MRE
                  </Link>
                  <Link to="/sidom-misim" className="hover:text-sidom-orange">
                    SIDOM MiSIM
                  </Link>
                </div>
                <div className="flex-1 flex  flex-col gap-2 text-sidom-light text-left mt-6 md:mt-0 min-w-[100px] max-w-[150px]">
                  <h2 className="text-lg font-bold">Nosotros</h2>
                  <Link to="/aboutus" className="hover:text-sidom-orange">
                    Sobre nosotros
                  </Link>
                  <Link
                    to="/privacy-policy"
                    className="hover:text-sidom-orange"
                  >
                    Políticas de privacidad
                  </Link>
                  <a
                    href="https://atencion.sidom.io/support/login?__hstc=225037893.bf6afd0faaabac1c77500320d4a80f00.1747164551158.1748618928409.1748630588818.11&__hssc=225037893.16.1748630588818&__hsfp=611053511"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-sidom-orange"
                  >
                    Soporte
                  </a>
                </div>
                <div className="flex-1 flex   flex-col text-balance text-sidom-light mt-6 md:mt-0 min-w-[100px] max-w-[160px]">
                  <h2 className="text-lg font-bold">Contacto</h2>
                  <p>
                    Camila O’Gorman 412 Piso 6,
                    <br /> Puerto Madero, Argentina
                  </p>
                  <br />
                  <p>
                    Ruta 8 Km. 17.500, Edificio @3 <br /> Of. 104, Zonamérica,
                    Montevideo, Uruguay
                  </p>{" "}
                  <br />
                  <p>Teléfono: +54 11 3724 1700 </p>
                  <br /> <a href="mailto:comercial@sidom.io">Enviar correo</a>
                  <ul className="list-none text-start gap-5 mt-3 mb-3 space-x-1">
                    <li className="inline mb-0">
                      <a
                        href="https://instagram.com/sidomsuite"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="h-8 w-8 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-[15px] text-center rounded-xl bg-sidom-blue hover:bg-orange-600 border border-orange-500 hover:border-orange-600 text-white"
                      >
                        <FiInstagram className="h-[14px] w-[14px] align-middle" />
                      </a>
                    </li>
                    <li className="inline pl-3">
                      <a
                        href="https://www.linkedin.com/company/sidomgt"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="h-8 w-8 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-[15px] text-center rounded-xl bg-sidom-blue hover:bg-orange-600 border border-orange-500 hover:border-orange-600 text-white"
                      >
                        <FiLinkedin className="h-[14px] w-[14px] align-middle" />
                      </a>
                    </li>
                  </ul>
                  <div className="mt-2 md:mt-0">
                    <p className="text-sidom-light">
                      Copyright © {new Date().getFullYear()} SIDOM.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
